<template>
  <div>
    <div v-if="historie.isEditable" class="d-flex justify-end">
      <v-btn
        text
        small
        color="primary"
        @click="showDateChangeModal = true"
      >
        Datumskorrektur
      </v-btn>
    </div>
    <v-row justify="space-between">
      <v-col cols="5">
        <zaehler-daten :wasserzaehler="historie.wasserzaehler"/>
        <div v-if="hasAnswers" class="ml-2">
          <v-row v-for="a in historie.answers" :key="a.question" class="mt-4">
            <v-col>{{a.question}}</v-col>
            <v-col cols="auto">{{a.answer}}</v-col>
          </v-row>
        </div>
      </v-col>
      <v-col cols="5">
        <zaehler-stand :wasserzaehler="historie.wasserzaehler" :verbrauch-warning="historie.wasserzaehler.letzterVerbrauch < 0" />
        <div class="ml-2">
          <v-row v-if="wayOfReading" class="mt-4">
            <v-col>Wie wurde die Ablesung gemeldet?</v-col>
            <v-col cols="auto">{{wayOfReading}}</v-col>
          </v-row>
        </div>
      </v-col>
    </v-row>
    <div v-if="historie.isEditable && aufgabe.isActive" class="d-flex justify-end">
      <v-btn
        color="info"
        class="white--text"
        @click="showEditDialog"
      >
        <v-icon left dark>edit</v-icon>
        Korrigieren
      </v-btn>
    </div>

    <ImageGallery :images="galleryImages" />

    <v-dialog v-model="showEditModal" :persistent="true" max-width="500px">
      <edit-ablesung
        v-if="showEditModal"
        :ablesung="historie"
        lastReading="10"
        @confirm="onEditConfirmed"
        @cancel="onEditCanceled"
      />
    </v-dialog>
    <v-dialog v-model="showDateChangeModal" :persistent="true" max-width="500px">
      <change-date
        v-if="showDateChangeModal"
        :initialDate="historie.date"
        :lastHistoryDate="previousHistoryDate"
        @confirm="onDateChangeConfirmed"
        @cancel="showDateChangeModal = false"
      />
    </v-dialog>
  </div>
</template>

<script>

import util from '@/util';
import urljoin from 'url-join';
import ImageGallery from '../common/ImageGallery';
import ChangeDate from '../aufgaben/ChangeDate';
import EditAblesung from '../aufgaben/EditAblesung';
import wasserparkApi from '../../wasserparkApi';
import ZaehlerDaten from "@/components/common/ZaehlerDaten";
import ZaehlerStand from "@/components/common/ZaehlerStand";

import authUtils from '@/security/utils';
const fotosUrlBase = util.getApiUrl();

export default {
  name: 'AblesungHistorieView',
  components: {
    ZaehlerDaten,
    ZaehlerStand,
    ImageGallery,
    ChangeDate,
    EditAblesung,
  },
  props: ['historie', 'aufgabe', 'previousHistoryDate'],
  computed: {
    hasAnswers() {
      return this.historie.answers && this.historie.answers.length > 0;
    },
    wayOfReading() {
      return this.historie.wayOfReading;
    },
    galleryImages() {
      if (!this.historie ||
        !this.historie.fotoGallerien ||
        (this.historie.fotoGallerien.length <= 0)) {
        return [];
      }

      return this.historie.fotoGallerien[0].fotos.map(f => ({
        thumbnail: urljoin(fotosUrlBase, f.vorschaubildUrl, `?api_key=${authUtils.getAccessToken()}`),
        image: urljoin(fotosUrlBase, f.url, `?api_key=${authUtils.getAccessToken()}`),
      }));
    },
  },
  methods: {
    onDateChangeConfirmed(date) {
      wasserparkApi.editAblesungDate(
        this.aufgabe.id,
        date,
      ).then((r) => {
        this.$emit('changed', r.data);
        this.showDateChangeModal = false;
      });
    },
    onEditConfirmed(ablesungUpdate) {
      wasserparkApi.editAblesung(
        this.aufgabe.id,
        this.historie.wasserzaehler.id,
        ablesungUpdate,
      ).then((r) => {
        this.$emit('changed', r.data);
        this.showEditModal = false;
      });
    },
    onEditCanceled() {
      this.showEditModal = false;
    },
    showEditDialog() {
      this.showEditModal = true;
    },
  },
  data() {
    return {
      showEditModal: false,
      showDateChangeModal: false,
    };
  },
};
</script>
